"use strict";

exports.__esModule = true;
exports.Content = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHooks = require("@okee-uikit/react-hooks");

var _reactUtils = require("@okee-uikit/react-utils");

var _reactConfig = require("@okee-uikit/react-config");

var _excluded = ["show", "prefixCls", "className", "enableSize", "icon", "style", "width", "divider", "header", "footer", "children", "containerRef", "inModal"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Content = function Content(props) {
  var show = props.show,
      prefixCls = props.prefixCls,
      className = props.className,
      _props$enableSize = props.enableSize,
      enableSize = _props$enableSize === void 0 ? false : _props$enableSize,
      icon = props.icon,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      width = props.width,
      divider = props.divider,
      header = props.header,
      footer = props.footer,
      children = props.children,
      _props$containerRef = props.containerRef,
      outerRef = _props$containerRef === void 0 ? null : _props$containerRef,
      inModal = props.inModal,
      extra = _objectWithoutPropertiesLoose(props, _excluded);

  var containerRef = (0, _react.useRef)(null);
  var headerRef = (0, _react.useRef)(null);
  var footerRef = (0, _react.useRef)(null);
  var bodyRef = (0, _react.useRef)(null);
  var update = (0, _reactHooks.useForceUpdate)();
  var ref = (0, _reactHooks.useCombineRef)(containerRef, outerRef);
  var containerSize = (0, _reactHooks.useElementSize)(containerRef, function () {
    return enableSize;
  }, update);
  var headerSize = (0, _reactHooks.useElementSize)(headerRef, function () {
    return enableSize;
  }, update);
  var footerSize = (0, _reactHooks.useElementSize)(footerRef, function () {
    return enableSize;
  }, update);
  var bodySize = (0, _reactHooks.useElementSize)(bodyRef, function () {
    return enableSize;
  }, update);
  var innerHeight = containerSize.height - headerSize.height - footerSize.height;
  var isInnerHeightScroll = enableSize && innerHeight < bodySize.height;
  var cls = (0, _reactUtils.classnames)((0, _reactConfig.usePrefixCls)('content-container'), (0, _reactConfig.usePrefixCls)(prefixCls + "-container"), className);
  var height = style.height,
      maxHeight = style.maxHeight;
  var withNumberHeight = height == null ? false : typeof height === 'number' ? true : !!height.match(/\d/g);
  var withNumberMaxHeight = maxHeight == null ? false : typeof maxHeight === 'number' ? true : !!maxHeight.match(/\d/g);
  var innerCls = (0, _reactUtils.classnames)((0, _reactConfig.usePrefixCls)('content-inner', {
    notModal: !inModal || withNumberHeight || withNumberMaxHeight
  }), (0, _reactConfig.usePrefixCls)(prefixCls + "-inner", {
    'no-footer': !footer,
    overflow: isInnerHeightScroll
  }));
  var iconWrapperCls = (0, _reactUtils.classnames)((0, _reactConfig.usePrefixCls)('content-icon-wrapper'), (0, _reactConfig.usePrefixCls)(prefixCls + "-icon-wrapper"));
  var innerWrapperCls = (0, _reactUtils.classnames)((0, _reactConfig.usePrefixCls)('content-inner-wrapper'), (0, _reactConfig.usePrefixCls)(prefixCls + "-inner-wrapper"));
  var headerCls = (0, _reactUtils.classnames)((0, _reactConfig.usePrefixCls)('content-header'), (0, _reactConfig.usePrefixCls)(prefixCls + "-header", {
    overflow: isInnerHeightScroll,
    divider: divider
  }));
  var footerCls = (0, _reactUtils.classnames)((0, _reactConfig.usePrefixCls)('content-footer'), (0, _reactConfig.usePrefixCls)(prefixCls + "-footer", {
    overflow: isInnerHeightScroll,
    divider: divider
  }));
  var renderIconWrapper = (0, _react.useCallback)(function (iconJsx) {
    if (!icon) {
      return null;
    }

    return _react.default.createElement("div", {
      className: iconWrapperCls
    }, iconJsx);
  }, [icon]);

  var renderHeader = function renderHeader() {
    if (!header) {
      return null;
    }

    return _react.default.createElement("div", {
      ref: headerRef,
      className: headerCls
    }, renderIconWrapper(icon), _react.default.createElement("div", {
      className: innerWrapperCls
    }, typeof header === 'function' ? header() : header));
  };

  var renderFooter = function renderFooter() {
    if (!footer) {
      return null;
    }

    return _react.default.createElement("div", {
      ref: footerRef,
      className: footerCls
    }, renderIconWrapper(), _react.default.createElement("div", {
      className: innerWrapperCls
    }, typeof footer === 'function' ? footer() : footer));
  };

  var tabIndexRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      ActiveElement = _useState[0],
      setActiveElement = _useState[1];

  (0, _react.useEffect)(function () {
    var _a, _b;

    if (show === undefined) {
      return;
    }

    if (show) {
      setActiveElement(document.activeElement);
      (_a = tabIndexRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    } else {
      (_b = tabIndexRef.current) === null || _b === void 0 ? void 0 : _b.blur();
      ActiveElement && ActiveElement.focus && typeof ActiveElement.focus === 'function' && ActiveElement.focus();
    }

    return function () {
      var _a;

      if (document.activeElement === tabIndexRef.current) {
        (_a = tabIndexRef.current) === null || _a === void 0 ? void 0 : _a.blur();
      }
    };
  }, [show]);
  return _react.default.createElement("div", _extends({}, extra, {
    ref: ref,
    className: cls,
    style: _extends({}, style, {
      width: width != null ? width : style.width
    })
  }), _react.default.createElement("div", {
    ref: tabIndexRef,
    tabIndex: -1
  }), renderHeader(), _react.default.createElement("div", {
    className: innerCls,
    style: {
      height: enableSize ? innerHeight + "px" : undefined
    }
  }, renderIconWrapper(!header && icon), _react.default.createElement("div", {
    className: innerWrapperCls,
    ref: bodyRef
  }, typeof children === 'function' ? children() : children)), renderFooter());
};

exports.Content = Content;